import { createAction } from '@reduxjs/toolkit';

export const fetchGeneralCategoriesRequestAction = createAction<{}, 'FETCH_GENERAL_CATEGORIES_REQUEST'>('FETCH_GENERAL_CATEGORIES_REQUEST');
export const fetchGeneralCategoriesSuccessAction = createAction<{ items: any; }, 'FETCH_GENERAL_CATEGORIES_SUCCESS'>('FETCH_GENERAL_CATEGORIES_SUCCESS');
export const fetchGeneralCategoriesErrorAction = createAction<{}, 'FETCH_GENERAL_CATEGORIES_ERROR'>('FETCH_GENERAL_CATEGORIES_ERROR');
